import { useQuery } from "@tanstack/react-query";
import { http } from "../../utils/httpCommon";
import { OldRoutesSchema } from "../../types/route.type";
import { useApiUrls } from "../useApiUrl";
import { useIsFeatureFlagEnabled } from "../../featureFlags/useIsFeatureFlagEnabled";
import { apiUrls } from "../../utils/apiUrls";

const useRoutesKeys = {
  routes: (serviceCenterId: number) => ["routes", serviceCenterId],
  route: (serviceCenterId: number, routeId: number) => [
    "routes",
    serviceCenterId,
    routeId,
  ],
  validateZipCode: (serviceCenterId: number, zipCode: string) => [
    "routes",
    serviceCenterId,
    "zipcodes",
    zipCode,
  ],
};

export const useRoutesAndTrapsOld = (
  serviceCenterId: number,
  enabled = true
) => {
  const isFeatureFlagEnabled = useIsFeatureFlagEnabled(
    "inbound-3763-endpoint-hook-client"
  );
  const hookUrls = useApiUrls();
  const urls = isFeatureFlagEnabled ? hookUrls : apiUrls;

  const getRoutesAndTraps = async (sicId: number) => {
    const { data } = await http.get(urls.getRoutesAndTraps, {
      params: { sicId },
    });
    return OldRoutesSchema.parse(data);
  };
  return useQuery({
    enabled,
    queryKey: useRoutesKeys.routes(serviceCenterId),
    queryFn: () => getRoutesAndTraps(serviceCenterId),
  });
};
